



























import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import LoadingIndicator from '@/components/LoadingIndicator'
import RequestButton from '@/components/RequestButton'

settings =
  name: 'OrganizerSettingsModal'

  resources:
    organizer:
      resourceName: 'organizer'
      slug: 'suppliers/:supplierId/organizers/:organizerId/edit'
      fetch: false

  vue:
    props: ['show', 'options']

    components: {
      Modal,
      LoadingIndicator,
      RequestButton,
    }

    computed:
      supplierId: ->
        return @options.supplierId if @currentMemberIsSuperUser()
        @$store.member.supplier.id

      organizerId: ->
        return @options.organizerId if @currentMemberIsSuperUser()
        @$store.member.organizer.id

      minPayoutInDollars:
        get: -> @prime?.organizer?.min_payout_in_cents / 100
        set: (value) -> @prime?.organizer?.min_payout_in_cents = value * 100

    methods:
      hiSave: ->
        @saveItemField 'organizer', 'min_payout_in_cents'
        @close()

      close: ->
        @$emit 'update:show', false

    watch:
      show:
        immediate: true
        handler: (show) ->
          @fetch 'organizer' if show

export default VueOptions.vue settings
